import React from "react";
import "../assets/styles/footer.css";

const Footer = () => {
  return (
    <div className="footer_component">
      <p>
        Copyright &#169; Talent Pool Company 2021,
        <br />
        All right reserved
      </p>
    </div>
  );
};

export default Footer;
